export default __webpack_public_path__ + "static/media/introduction.7a01823e.jpg";